import type { CartUI } from '@libs/common-node';
import type { QueryClient } from '@tanstack/react-query';
import { logConsoleError } from '../../utils';
import { asyncForEach } from './asyncForEach';
import { COMPONENTS, CART_ERROR_MESSAGES } from '../../constants';
import { DeliveryType } from '../../../../core/src';
import { storeQueryFactory } from '../StoreProvider/queries/useStoreQuery';

export default async function fetchAndMergeStores(cart: CartUI, queryClient: QueryClient): Promise<CartUI> {
    const hasBopisInCart = cart?.fulfillmentGroups?.some(
        ({ fulfillmentMethod }) => fulfillmentMethod?.toLowerCase() === DeliveryType.BOPIS
    );

    if (!hasBopisInCart) {
        return cart;
    }

    const updatedCart = structuredClone(cart);

    await asyncForEach(updatedCart.fulfillmentGroups, async (group, index) => {
        if (group.storeId) {
            try {
                const storeId = String(group.storeId);
                const store = await queryClient.fetchQuery(storeQueryFactory(storeId));
                if (!store) {
                    throw new Error('Error getting StoreV2 by Id');
                }
                updatedCart.fulfillmentGroups[index].store = store;
            } catch (e) {
                logConsoleError(JSON.stringify(e), {
                    component: COMPONENTS.CART_PROVIDER,
                    severity: 'MEDIUM',
                    additionalInfo: CART_ERROR_MESSAGES.FETCH_STORES_FAILED,
                });
                updatedCart.fulfillmentGroups[index].store = null;
            }
        }
    });

    return updatedCart;
}
